import React from "react";
import "./Invoices.css";

const Invoices = () => {
  return <div className="invoices-container">Invoices are under development !!! <br /> Stay tuned...</div>;
};

export default Invoices;
